<div *ngIf="checkViewMode('edit')" [class]="'form-group txt_'+getOptionByKey(attribute,'identifier')">
  <label for="">
    {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>

  <div class="form-group input-datepicker">
    <div class="form-control">
      <i class="fa fa-calendar"></i>
      <ngx-datepicker
      [ngModel]="date"
      [options]="options"
      [class]="' txt_'+getOptionByKey(attribute,'identifier')"
      [id]="'txt_'+getOptionByKey(attribute,'identifier')"
      [disabled]="getOptionByKey(attribute,'disabled')"
      (ngModelChange)="changedDate($event)">
    </ngx-datepicker>
      <!-- <i class="fa fa-times" aria-hidden="true" (click)="clearDate()" [hidden]="!date"></i> -->
    </div>
  </div>
</div>

<div *ngIf="checkViewMode('view')">
  <p><span>{{ getTitle() }}: </span> {{attribute.value | date}}</p>
</div>
